import { CLASS_CONTROL, CLASS_UNSELECTABLE } from 'ol/css';

import { AbstractLayerControl, AbstractLayerEntry } from './abstract_layer_control';
import { WMSLayer, LEGEND_SIZE_KEY } from '../wms_layer';

import { NAME_KEY, LEGEND_URL_KEY, LEGEND_VISIBLE_KEY } from '../layer';

import EventType from 'ol/events/EventType';

import { listen } from 'ol/events';
import { unByKey } from 'ol/Observable';

import { faSquareMinus, faSquarePlus } from '@fortawesome/pro-regular-svg-icons';
import { icon } from '@fortawesome/fontawesome-svg-core'

import { createElement } from '../../util/element';

import './legend.css';

class ImageWrapper {
	constructor( image ) {
		this.image = image;
	}
	
	getImage() {
		return this.image;
	}
}

class LegendEntry extends AbstractLayerEntry {
	constructor( layer, parent ) {
		super(layer);
		this.control = parent;
        this.element = createElement("div", "entry");
        this.control.element.insertBefore(this.element, this.control.element.firstChild);

				
		this.listen(this.layer.on("propertychange", ({ key }) => {
			if( key === NAME_KEY || key === LEGEND_URL_KEY || key === LEGEND_SIZE_KEY || key === LEGEND_VISIBLE_KEY ) {
				this.updateLegend();
			}
		}));
		
		this.listen(this.layer.on("change:visible", () => this.updateLegend()));
		this.listen(this.layer.on("change:zIndex", () => this.updateOrder()));
		
		this.expanded = true;
		
		if( this.instance instanceof WMSLayer ) {
			this.listen( this.source.on('change', () => this.updateLegend()));
		}
	}

	getResolution() {
		return this.control.getMap().getView().getResolution();
	}
	
	hasLegend() {
		return this.instance.hasLegend(this.getResolution());
	}
	
	updateLegend() {
		let url = null;

		if( this.instance.isVisible() && this.instance.isLegendVisible() ) {
			url = this.instance.getLegendUrl(this.getResolution());
		}		
								
		if( url != null && this.header === undefined ) {		
			this.setupElement( url );
			
			const handler = this.instance.getLegendClickHandler();
			if( handler != null ) {
				this.listenKey = listen(this.element, EventType.CLICK, event => {
					handler();
				});	
			}
			
		} else if( url != null && this.header !== undefined ) { 
			this.updateUrl( url );
		} if( !url && this.header !== undefined ) { 
			this.hide();
		}
	}
	
	updateUrl(url) {
		this.element.style.display = 'initial';
		
		if( this.timer ) {
			clearTimeout( this.timer );
			this.timer = null;
		}
		
		if( this.label ) {
			this.label.innerText = this.instance.getName() || "";		
		}		
		
		let loader = null;		
		if( this.source && this.source.getImageLoadFunction() ) {		
			loader = this.source.getImageLoadFunction(); 
		} else {
			loader = (img, url) => img.getImage().src = url;
		}
		
		this.timer = setTimeout(() => {
			if( this.imageWrapper ) {
				loader(this.imageWrapper, url);
			}
		}, 250);
	}
	
	updateOrder() {
        if( this.element ) {
            const index = this.layer.getZIndex();
            this.element.style.order = this.control.getLayers().length - index;
            console.log(this.control.getLayers().length, index, this.element.style.order);
        }
    }

	setupElement(url) {
        this.header = createElement("div", "header", this.element);

        this.label = createElement("h4", "label", this.header);
		this.label.innerText = this.instance.getName() || "";
				
        this.link = createElement("a", "status", this.header);
        this.link.href = "#";		
				
		this.htmlIcon = icon(faSquareMinus).node[0];
        this.link.appendChild(this.htmlIcon);

		this.image = new Image();
		this.imageWrapper = new ImageWrapper(this.image);
		
        this.element.appendChild(this.image);

		this.updateUrl( url );
		
		this.link.addEventListener(EventType.CLICK, e => this.expand(e), false);		
	}
	
	removeElement() {
		if( this.element ) {
			this.control.element.removeChild( this.element );
			unByKey(this.listenKey);
			
			this.element = undefined;
			this.label = undefined;
			this.image = undefined;
			this.listenKey = undefined;
		} 
	}
	
	hide() {
		if( this.element ) {
			this.element.style.display = 'none';
		}
	}
	
	remove() {
		this.removeElement();
		super.remove();
	}
	
	expand(e) {
        // prevent HREF call
        e.preventDefault();
        //
        e.stopPropagation();
        
        this.expanded = !this.expanded;
        this.element.classList.toggle("collapsed", !this.expanded);
        
        if( this.htmlIcon ) {
            this.link.removeChild( this.htmlIcon );            
        }
        
        const iconName = this.expanded ? faSquareMinus : faSquarePlus;
        
        this.htmlIcon = icon(iconName).node[0];
        this.link.appendChild(this.htmlIcon);
    }
}

class Legend extends AbstractLayerControl {

	constructor( opt_options ) {
		const options = opt_options ? opt_options : {};	
		super(options);
		
		const className = options.className !== undefined ? options.className : 'ol-legend';
		const containerElement = this.element;
		
		containerElement.className = `${className} ${CLASS_UNSELECTABLE} ${CLASS_CONTROL}`;
		this.handlers = [];
	}
		
	createEntry( layer ) {
		return new LegendEntry(layer, this);
	}
	
	setMap(map) {
		super.setMap(map);
		
		if( map != null ) {
			map.getView().on("change:resolution", () => this.refresh());		
		}		
	}	
			
	refresh() {						
		this.getLayers()
		.forEach( e => e.updateLegend());		
	}
	
	refreshOrder() {
         this.getLayers()
        .forEach( e => e.updateOrder());
    }
}

export {
	Legend
}

